import {
    getTxprDscmNoEncCntn, getTxprNm, getBmanClNm, getRprsTxprNm, getRprsResno, getAgentBsno, getAgentNm,
    getJusoCode, getJusoSido, getJusoSigu, getJusoRoad, getJusoPriNo, getJusoSubNo, getJusofullAddr,
    getTelNo, getBizGubun,
} from "@/utils/nicetaxUtils";


const sessionStore = {
    namespaced: true,
    state: {
        //최초 접근인지 아닌지 판별하는 변수
        initialized: false,

        // 최초 메인페이지 접근시 URL 파라미터 정보
        // userType, num, returnUrl, memberNo, singoYear
        accessInfo: {},

        // 로그인시 입력한 정보
        // userId, userPw, userValidNo, agentId, agentPw, bizNo
        loginInfo: {},

        //인증서 정보
        // signCert, signPri, signPw
        certInfo: {},

        // 신청시 필요한 분기값 및 사용자 입력 / 선택값
        // sendType, mktAyn, userNm, telNo1~3, email, rcvOrg, bizNo(RS 신청용)
        applyInfo: {},

        // 홈택스 사업자증명 스크래핑 리턴값 정제, 타 증명서 스크래핑시 필요한 정보
        bizInfo: {},
    },
    getters: {
        // 최초 메인페이지 접근시 URL 파라미터 정보
        accessInfo(state) {
            return state.accessInfo;
        },
        userType(state) {
            return state.accessInfo.userType;
        },
        num(state) {
            return state.accessInfo.num;
        },
        returnUrl(state) {
            return state.accessInfo.returnUrl;
        },
        isInitialized(state) {
            return state.initialized;
        },

        //인증서 정보 
        signCert(state) {
            return state.certInfo.file1;
        },
        signPri(state) {
            return state.certInfo.file2;
        },
        signPw(state) {
            return state.certInfo.cert_pw;
        },
        signOid(state) {
            return state.certInfo.oid;
        },
        signPub(state) {
            return state.certInfo.org_nm;
        },
        signFromDt(state) {
            return state.certInfo.pub_dt;
        },
        signToDt(state) {
            return state.certInfo.end_dt;
        },

        //로그인 입력값 정보
        userId(state) {
            return state.loginInfo.userId;
        },
        userPw(state) {
            return state.loginInfo.userPw;
        },
        userValidNo(state) {
            return state.loginInfo.userValidNo;
        },
        agentId(state) {
            return state.loginInfo.agentId;
        },
        agentPw(state) {
            return state.loginInfo.agentPw;
        },
        bizNo(state) {
            return state.loginInfo.bizNo;
        },
        bizGubun(state) {
            return getBizGubun(state.loginInfo.bizNo);
        },

        //신청 정보
        sendType(state) {
            return state.applyInfo.sendType;
        },
        userNm(state) {
            return state.applyInfo.userNm;
        },
        applyBizNo(state) {
            return state.applyInfo.bizNo;
        },

        //홈택스 사업자증명원
        txprDscmNoEncCntn(state) {
            return state.bizInfo.txprDscmNoEncCntn;
        },
        txprNm(state) {
            return state.bizInfo.txprNm;
        },
        bmanClNm(state) {
            return state.bizInfo.bmanClNm;
        },
        rprsTxprNm(state) {
            return state.bizInfo.rprsTxprNm;
        },
        agentBsno(state) {
            return state.bizInfo.agentBsno;
        },
        agentNm(state) {
            return state.bizInfo.agentNm;
        },
        rprsResno(state) {
            return state.bizInfo.rprsResno;
        },
        jusoCode(state) {
            return state.bizInfo.jusoCode;
        },
        jusoSido(state) {
            return state.bizInfo.jusoSido;
        },
        jusoSigu(state) {
            return state.bizInfo.jusoSigu;
        },
        jusoRoad(state) {
            return state.bizInfo.jusoRoad;
        },
        jusoPriNo(state) {
            return state.bizInfo.jusoPriNo;
        },
        jusoSubNo(state) {
            return state.bizInfo.jusoSubNo;
        },
        jusofullAddr(state) {
            return state.bizInfo.jusoSubNo;
        },
        telNo1(state) {
            return state.bizInfo.telNo[0];
        },
        telNo2(state) {
            return state.bizInfo.telNo[1];
        },
        telNo3(state) {
            return state.bizInfo.telNo[2];
        },
    },
    mutations: {
        SET_INITIALIZED(state) {
            state.initialized = true;  // 초기화 완료
        },
        SET_ACCESS_INFO(state, accessInfo) {
            state.accessInfo = accessInfo;
        },
        CLEAR_STORAGE(state) {
            state.certInfo = {};
            state.applyInfo = {};
            state.bizInfo = {};
        },

        SET_LOGIN_INFO(state, loginInfo) {
            state.loginInfo = loginInfo;
        },
        SET_CERT_INFO(state, certInfo) {
            state.certInfo = certInfo;
        },

        ADD_APPLY_INFO_PROPS(state, applyInfo) {
            Object.assign(state.applyInfo, applyInfo);
        },
        SET_BIZ_INFO(state, bizInfo) {
            state.bizInfo = bizInfo;
        },
        ADD_BIZ_INFO_PROPS(state, bizInfo) {
            Object.assign(state.bizInfo, bizInfo);
        },
    },
    actions: {
        SAVE_INITIAL_ACCESS_INFO({ commit }, accessInfo) {
            commit("SET_INITIALIZED");
            commit("SET_ACCESS_INFO", accessInfo);
        },
        CLEAR_SESSION({ commit }) {
            commit("CLEAR_STORAGE");
        },
        SAVE_LOGIN_INFO({ commit }, loginInfo) {
            commit("SET_LOGIN_INFO", loginInfo);
        },
        SAVE_CERT({ commit }, certInfo) {
            commit("SET_CERT_INFO", certInfo);
        },
        ADD_APPLY_INFO({ commit }, applyInfo) {
            commit("ADD_APPLY_INFO_PROPS", applyInfo);
        },
        SAVE_BIZ_INFO({ commit }, data) {
            commit("SET_BIZ_INFO", {
                txprDscmNoEncCntn: getTxprDscmNoEncCntn(data),  //스크래핑 대상 사업자번호
                txprNm: getTxprNm(data),    // 스크래핑 대상 상호명 혹은 대표자명
                bmanClNm: getBmanClNm(data),    //사업자 유형(법인/개인 등)
                rprsTxprNm: getRprsTxprNm(data),
                rprsResno: getRprsResno(data),
                jusoCode: getJusoCode(data),
                jusoSido: getJusoSido(data),
                jusoSigu: getJusoSigu(data),
                jusoRoad: getJusoRoad(data),
                jusoPriNo: getJusoPriNo(data),
                jusoSubNo: getJusoSubNo(data),
                jusofullAddr: getJusofullAddr(data),
                telNo: getTelNo(data),
                agentBsno: getAgentBsno(data),  //전송자 사업자번호
                agentNm: getAgentNm(data),      //전송자 기업명 혹은 대표자명
            });
        },
    },
};

export default sessionStore; 